<!--  -->
<template>
  <div class="active">
    <div class="top">
      <el-radio-group v-model="type">
        <el-radio-button label="2">推送规则</el-radio-button>
        <el-radio-button label="1">推送内容</el-radio-button>
      </el-radio-group>
    </div>
    <div class="box">
      <!--推送设置 -->
      <div class="box2" v-if="type == 2">
        <div class="box2Top">推送规则</div>
        <el-form ref="form" :model="form" label-width="120px">
          <el-form-item label="规则名称">
            <el-input v-model="form.name" size="small"></el-input>
          </el-form-item>
          <el-form-item label="互动类型">
            <el-select v-model="form.type" size="small" placeholder="请选择">
              <el-option
                v-for="item in interactData"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="推送时间">
            <el-radio-group v-model="form.send_time">
              <el-radio label="1">立即发送</el-radio>
              <el-radio label="2">等待发送</el-radio>
              <el-radio label="3">定期发送</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="form.send_time == 2">
            等待
            <el-select
              v-model="form.hour"
              size="small"
              class="inputWidth"
              placeholder="请选择"
            >
              <el-option
                v-for="item in 47"
                :key="item"
                :label="item"
                :value="item"
              ></el-option> </el-select
            >小时，
            <el-select
              v-model="form.minute"
              size="small"
              class="inputWidth"
              placeholder="请选择"
            >
              <el-option
                v-for="item in 59"
                :key="item"
                :label="item"
                :value="item"
              ></el-option> </el-select
            >分，发送
          </el-form-item>
          <el-form-item v-if="form.send_time == 3">
            <el-select
              v-model="form.timing_time"
              size="small"
              class="inputWidth"
              placeholder="请选择"
            >
              <el-option label="每日" value="everyday"></el-option>
              <el-option label="每周" value="weekly"></el-option>
            </el-select>
            <el-select
              v-model="form.weekArr"
              size="small"
              multiple
              placeholder="请选择"
              v-if="form.timing_time == 'weekly'"
            >
              <el-option
                :label="item.label"
                :value="item.value"
                v-for="(item, index) in weekData"
                :key="index + 1"
              ></el-option>
            </el-select>
            <el-time-picker
              v-model="form.time"
              size="small"
              :picker-options="{
                selectableRange: '08:00:00 - 18:30:00',
              }"
              arrow-control
              value-format="HH:mm:ss"
              placeholder="选择时间"
              class="inputWidth"
            ></el-time-picker>
          </el-form-item>
          <el-form-item label="规则生效时间">
            <el-radio-group v-model="form.is_forever">
              <el-radio label="1">不限</el-radio>
              <el-radio label="0">自定义</el-radio>
            </el-radio-group>
            <el-date-picker
              v-if="form.is_forever == '0'"
              v-model="form.foreverTime"
              size="small"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="消息去重">
            <el-radio-group v-model="form.is_differ">
              <el-radio label="1">开启</el-radio>
              <el-radio label="0">关闭</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- <el-form-item>
            <el-button type="primary" @click="onSubmit">立即创建</el-button>
            <el-button>取消</el-button>
          </el-form-item>-->
        </el-form>
      </div>
      <!--推送内容  -->
      <div class="box1" v-if="type == 1">
        <!-- <div class="title">
          一次最多支持发送10条消息，为了不影响用户体验，建议一次只发一条
        </div>-->

        <!-- 消息显示 (当添加按钮为true，and 有添加内容的时候 才显示) -->
        <div
          :class="
            previewId == item.id
              ? 'showMessage currentShowMessage'
              : 'showMessage'
          "
          v-show="addBtnStatus && showMessageData.length != 0"
          v-for="(item, index) in showMessageData"
          :key="index"
          @click="setPreview(item.id)"
        >
          <div class="showMessageContent">
            <div v-if="item.type == 'text'" v-html="item.value"></div>
            <div class="pictureBox left" v-if="item.type == 'image'">
              <div class="bigArticleBox">
                <img :src="item.url" />
              </div>
              <p class="fileName ellipsis">图片</p>
            </div>
            <div class="pictureBox left" v-if="item.type == 'news'">
              <div>{{ item.value.title }}</div>
              <div class="bigArticleBox">
                <img :src="item.value.image" />
              </div>
              <p class="fileName ellipsis">{{ item.value.desc }}</p>
            </div>
          </div>
          <div class="showMessageBtn">
            <i class="el-icon-edit" @click="editMessage(item, index)"></i>
            <i class="el-icon-delete" @click="deleteMessage(item, index)"></i>
          </div>
        </div>
        <!-- 文本编辑器 -->
        <div class="textEditor" v-if="!addBtnStatus">
          <!--文本域  -->
          <div id="text_area" contenteditable v-html="text"></div>
          <!-- 操作 -->
          <div class="options">
            <div class="optionLeft">
              <el-popover placement="bottom-start" width="400" trigger="click">
                <!-- 表情子组件 -->
                <Emojs @AppendInputValue="choseEmojs"></Emojs>
                <div class="icon face left" slot="reference"></div>
              </el-popover>
              <div
                title="插入粉丝昵称"
                class="icon nickNameIcon left"
                @click="addNickname"
              ></div>
              <el-popover
                placement="bottom-start"
                width="380"
                trigger="manual"
                v-model="visible"
              >
                插入链接内容
                <el-form label-width="80px" :model="linkData">
                  <el-form-item label="文字内容">
                    <el-input
                      placeholder="请输入内容"
                      v-model="linkData.text"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="文字链接">
                    <el-input
                      placeholder="请输入以http://开头的有效连接"
                      v-model="linkData.url"
                    >
                      <template slot="append">设置链接</template>
                    </el-input>
                  </el-form-item>
                  <el-form-item>
                    <div style="text-align: right; margin: 0">
                      <el-button @click="closeTextVisible">取消</el-button>
                      <el-button type="primary" @click="confirmTextVisible"
                        >确定</el-button
                      >
                    </div>
                  </el-form-item>
                </el-form>
                <div
                  class="icon linkIcon left"
                  slot="reference"
                  @click="visible = true"
                ></div>
              </el-popover>
            </div>
            <div class="optionRigth">
              <div class="wordnum textRight right">
                还可以输入 {{ 600 - text.length }} 字
              </div>
              <div class="subimitbtn right disabled" @click="save(1)">确定</div>
            </div>
          </div>
        </div>
        <div class="addMessage" v-show="addBtnStatus">
          <i class="el-icon-plus"></i>
          <div @click="addBtnStatus = false">
            <i class="el-icon-edit"></i>
            文本消息
          </div>
          <div @click="dialogVisible = true">
            <i class="el-icon-postcard"></i>
            图文消息
          </div>
          <div @click="typeImg(2)">
            <i class="el-icon-picture-outline"></i>
            图片
          </div>
          <!-- <div class="list">
            
          </div>-->
        </div>
      </div>
    </div>
    <div class="bottom">
      <el-button
        size="small"
        type="primary"
        plain
        v-if="type == 2"
        @click="type = 1"
        >下一步</el-button
      >
      <el-button
        size="small"
        @click="preview"
        :disabled="showMessageData.length && addBtnStatus > 0 ? false : true"
        v-if="type == 1"
        >预览</el-button
      >
      <el-button size="small" type="primary" v-if="type == 1" @click="type = 2"
        >上一步</el-button
      >
      <el-button
        size="small"
        type="primary"
        plain
        v-if="type == 1"
        @click="onSubmit"
        >保存</el-button
      >
    </div>
    <!-- 圖文彈窗 -->
    <el-dialog
      title="编辑图文消息"
      :visible.sync="dialogVisible"
      :show-close="false"
      width="774px"
    >
      <div id="fai-message-conten" class="clearfix">
        <div class="left">
          <div class="mItem">
            <div class="imgBox">
              <img
                :src="textData.image"
                class="target"
                v-if="textData.image != ''"
              />
              <img
                src="@public/img/market/defImage.jpg"
                class="target"
                v-else
              />
            </div>
            <div class="title">{{ textData.title }}</div>
          </div>
        </div>
        <div class="right" style="transform: translateY(0px);">
          <div class="arrow_out"></div>
          <div class="arrow_in"></div>
          <form>
            <div class="baseLine">
              <div class="baseLine2">封面介绍</div>
              <div class="baseLine2">
                <el-input
                  type="text"
                  placeholder="请填写此字段"
                  name="mText"
                  required="required"
                  maxlength="64"
                  class="faiui-input"
                  v-model="textData.title"
                ></el-input>
              </div>
              <div class="baseLine2 faiui-inputErrMsg" style="display: none;">
                不能为空且最多64个字
              </div>
            </div>
            <div class="baseLine">
              <!-- <div class="baseLine2">
                封面图片<a
                  href="https://kt.fkw.com/sheji.html?source_biz=3&amp;open_source=63003#/m/create"
                  target="_blank"
                  class="makePicture"
                  >制作封面</a
                >
              </div>-->
              <div class="baseLine2">
                <el-button
                  type="primary"
                  size="small"
                  icon="el-icon-upload2"
                  @click="typeImg(1)"
                  >上传</el-button
                >
                <el-button
                  size="small"
                  icon="el-icon-delete"
                  v-if="textData.image != ''"
                  @click="delUrl"
                  >删除</el-button
                >
              </div>
              <div class="baseLine2" v-if="textData.image != ''">
                <div class="imgBox">
                  <img :src="textData.image" class="target" />
                </div>
              </div>
            </div>
            <div class="baseLine">
              <div class="baseLine2">
                摘要
                <span class="exp"
                  >（选填，该摘要只在发送图文消息为单条时显示）</span
                >
              </div>
              <div class="baseLine2">
                <el-input type="textarea" v-model="textData.desc"></el-input>
                <!-- <textarea name="mDesc" class="faiui-input"></textarea> -->
              </div>
            </div>
            <div class="baseLine">
              <div class="baseLine2 faiui-urlInput">
                <el-input placeholder="http://" v-model="textData.url">
                  <template slot="append">设置链接</template>
                </el-input>
              </div>
            </div>
          </form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogPhotoClose(1)">取 消</el-button>
        <el-button type="primary" @click="imageTextConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 图片选择 -->
    <el-dialog
      title="选择图片"
      :visible.sync="dialogPhoto"
      width="670px"
      center
      :show-close="false"
    >
      <Phpto @choseImgValue="sendData"></Phpto>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogPhotoClose(0)" size="small">取 消</el-button>
        <el-button type="primary" @click="dialogPhotoBtn" size="small"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  materialAll,
  addMessage,
  detailMessage,
  smartRuleAdd,
  smartRuleEditor,
  smartRuleDetail,
  smartRuleDel,
  editMessage,
  preview,
} from "@/api/push";
import { allTag } from "@/api/market";
import { vipList } from "@/api/vip";
import Emojs from "@/components/public/emoj";
import Phpto from "../phopoPopUp";
export default {
  computed: {
    ...mapGetters(["token", "app_id"]),
  },
  components: {
    Phpto,
    Emojs,
  },
  data() {
    return {
      jude: 0, //0 为添加 1 为编辑
      weekData: [
        {
          label: "周一",
          value: "Mon",
        },
        {
          label: "周二",
          value: "Tue",
        },
        {
          label: "周三",
          value: "Wed",
        },
        {
          label: "周四",
          value: "Thur",
        },
        {
          label: "周五",
          value: "Fri",
        },
        {
          label: "周六",
          value: "Sat",
        },
        {
          label: "周日",
          value: "Sun",
        },
      ],
      interactData: [
        {
          label: "不限",
          value: "",
        },
        {
          label: "关注公众号",
          value: "subscribe",
        },
        {
          label: "发送消息",
          value: "chat",
        },
        {
          label: "点击菜单",
          value: "click",
        },
        {
          label: "扫码",
          value: "scan",
        },
      ], //互动类型
      previewId: "", //预览消息id
      type: 2, //配置类型
      page: 1,
      total: "0",
      dataList: [],
      dialogVisible: false,
      dialogPhoto: false,
      visible: false, //文本链接弹框
      linkData: {
        text: "",
        url: "",
      },
      // 配置
      form: {
        name: "", //规则名称
        send_time: "1", //发送时间
        hour: "",
        minute: "",
        timing_time: "everyday", //everyday 每日 weekly 每周
        weekArr: [], // 周的数据
        time: "", //时间点
        is_forever: "1", //是否永久有效 1是 0否
        foreverTime: [], //生效时间
        is_differ: "1", //是否需要消息去重 1是 0否
        type: "",
        level_id: "",
        mobile: "",
      },
      showMessageData: [], //每条信息
      text: "", // 正文 (编辑时的显示)
      textSend: "", //保存的数据
      sendType: "", //发送类型 text文本 image图片 video视频 voice声音 news图文
      textData: {
        title: "标题", //标题（图文）
        desc: "", //	描述
        url: "", //	url
        image: "", //	图片链接（图文）
      },
      object: [],
      // tagsData: [],
      vipData: [],
      addBtnStatus: true, //添加消息的列表
      imgData: "", //选择的图片信息
      dislogStatus: "1", //1 图文消息中图片选择 2，单个图片
      editSendData: {
        id: "", //信息id
        index: "", //标注编辑的第几条数据
        is_stataus: false, //状态
      }, //编辑时携带的参数
      editSend: "",
    };
  },

  created() {
    if (this.$route.query.jude) {
      this.editorInit();
      this.jude = 1;
    }
  },
  methods: {
    editorInit() {
      let data = {
        token: this.token,
        app_id: this.app_id,
        rule_id: this.$route.query.idJ,
      };
      smartRuleDetail(data).then((res) => {
        if (res.code == 200) {
          let shellData = res.data;
          this.form.name = shellData.name;
          this.form.id = shellData.message_id;
          this.form.is_differ = String(shellData.is_differ);
          this.form.is_forever = String(shellData.is_forever);
          if (shellData.send_time == 3) {
            //
            let is_status = false; // false 为每日 truev为每周的情况
            is_status = shellData.timing_time.everyday ? false : true;
            this.form.timing_time = is_status ? "weekly" : "everyday";
            if (is_status) {
              let arrShell = shellData.timing_time.weekly;
              this.form.weekArr = [];
              for (var i in arrShell) {
                console.log("it4em", i);

                this.form.weekArr.push(i);
                this.form.time = arrShell[i][0];
              }
              // arrShell.forEach(item => {
              // });
            }
            // 每周 每日
          }
          // 获取消息详情
          detailMessage({
            token: this.token,
            app_id: this.app_id,
            id: this.form.id,
          }).then((res) => {
            console.log("qqq", res);
            let type =
              res.data.type == "text"
                ? "1"
                : res.data.type == "image"
                ? "2"
                : "3";
            this.dispose(res.data, type);
            //
            // res.code =
          });
          // 发送类型
          // if (this.form.send_time == "2") {
          //   // 等待發送
          //   if (this.form.hour == "" || this.form.minute == "") {
          //     return this.$message.warning("请完善等待时间！！");
          //   } else {
          //     data.wait_time = {
          //       hour: this.form.hour,
          //       minute: this.form.minute
          //     };
          //   }
          // } else if (this.form.send_time == "3") {
          //   //定期发送
          //   if (this.form.timing_time == "everyday") {
          //     if (this.form.time == "") {
          //       this.form.weekArr = [];
          //       return this.$message.warning("请完善定期发送时间！！");
          //     } else {
          //       data.timing_time = {
          //         everyday: this.form.time
          //       };
          //     }
          //   } else {
          //     // 按周
          //     if (this.form.time == "" || this.form.weekArr.length == 0) {
          //       return this.$message.warning("请完善定期发送时间！！");
          //     } else {
          //       //  数据整合

          //       let objWeek = {}; //
          //       this.form.weekArr.forEach(item => {
          //         let arr = [];
          //         arr.push(this.form.time);
          //         objWeek[item] = arr;
          //       });
          //       data.timing_time = {
          //         weekly: objWeek
          //       };
          //     }
          //   }
          // }
          // //
          // if (this.form.is_forever == "0") {
          //   if (!this.form.foreverTime.length) {
          //     return this.$message.warning("请选择规则生效的时间！！");
          //   } else {
          //     data.start_time = this.form.foreverTime[0];
          //     data.end_time = this.form.foreverTime[1];
          //   }
          // }
          this.form.id = res.data.id;
          this.form.type = res.data.type;
          this.form.send_time = String(res.data.send_time);
          this.form;
        }
        console.log("详情", res);
      });
    },
    setPreview(id) {
      console.log("消息id", id);
      this.previewId = id;
    },
    // 文本链接弹框
    closeTextVisible() {
      this.visible = false;
      this.linkData = {
        text: "",
        url: "",
      };
    },
    confirmTextVisible() {
      // 添加光标
      this.keepLastIndex(document.getElementById("text_area"));
      // 添加带文本链接
      if (this.linkData.text == "") {
        this.$message.warning("请填写文本");
        return;
      }
      if (this.linkData.url == "") {
        this.$message.warning("请填写链接！！");
        return;
      }
      // 插入超链接
      document.execCommand(
        "insertHTML",
        false,
        `<a href='${this.linkData.url}'>${this.linkData.text}</a>`
      );
      // 清空并关掉弹窗
      this.visible = false;
      this.linkData = {
        text: "",
        url: "",
      };
    },
    addNickname() {
      this.keepLastIndex(document.getElementById("text_area"));
      document.execCommand(
        "insertImage",
        false,
        "https://yckj-common.oss-cn-beijing.aliyuncs.com/1598235903.png"
      );
      console.log("编辑器数据", this.text);
    },
    // 表情包选择
    choseEmojs(value) {
      let innerHTML = document.getElementById("text_area").innerHTML;
      this.text = innerHTML + value;
      console.log("表情包", this.text, value);
    },
    // 单图片
    typeImg(type) {
      // 1图文 2 单图片
      this.dislogStatus = type;
      this.dialogPhoto = true;
    },
    sendData(value) {
      this.imgData = value;

      console.log("value", value);
    },
    dialogPhotoBtn() {
      console.log("我走这又不");
      if (this.imgData != "") {
        if (this.dislogStatus == "1") {
          this.textData.image = this.imgData.url;
        } else {
          //2 图片消息上传
          this.save(2); // 2图片
        }
      }
      this.dialogPhoto = false;
    },
    imageTextConfirm() {
      // 判断填写信息是否正确
      // textData: {
      if (this.textData.image == "") {
        this.$message.warning("请先上传图片！！");
        return;
      }
      if (this.textData.url !== "" && this.textData.url.indexOf("http") != 0)
        return this.$message.warning("请正确填写链接");
      this.save(3); //图文上传！！
      this.dialogVisible = false;
      // 图文消息
    },
    save(sendTyle) {
      if (sendTyle == 1) {
        // 获取节点
        let innerHTML = document.getElementById("text_area").innerHTML;
        this.editSend = innerHTML;
        console.log("a", innerHTML);
        var imgMeassage =
          "<img src='https:bbzltc-1255680458.cos.ap-beijing.myqcloud.comb1598235903.png'>";
        var e = eval("/" + imgMeassage + "/g");
        this.textSend = innerHTML
          .replace(/"/g, "'")
          .replace(/&nbsp;/g, "")
          .replace(new RegExp("/", "g"), "b")
          .replace(e, "{$nickname}")
          .replace(/bb/, "//")
          .replace(/<b/, "</");
        console.log("文本数据", this.textSend);
      }
      // return;
      // 1,文本消息
      // type发送类型 text文本 image图片 video视频 voice声音 news图文
      if (sendTyle == 1 && this.textSend == "") {
        // this.$message.warning("您还没有填写要发送的消息！！");
        this.addBtnStatus = true;
        // 避免编辑状态混乱
        this.editSendData.is_stataus = false;
        return;
      }
      let data = {
        token: this.token,
        app_id: this.app_id,
      };
      switch (sendTyle) {
        case 1:
          data.type = "text";
          data.value = this.textSend;
          break;
        case 2:
          data.type = "image";
          data.value = this.imgData.media_id;
          break;
        case 3:
          data.type = "news";
          data.value = {};
          data.value = this.textData;
          break;
      }
      //
      if (!this.editSendData.is_stataus) {
        // 添加
        addMessage(data).then((res) => {
          console.log("添加数据", res);
          if (res.code == 200) {
            this.dispose(res.data, sendTyle);
          } else {
            this.$message.warning(res.msg);
          }
          this.addBtnStatus = true;
        });
      } else {
        // 消息编辑
        data.id = this.editSendData.id;
        editMessage(data).then((res) => {
          console.log("编辑数据", res);
          if (res.code == 200) {
            this.dispose(res.data, sendTyle);
          } else {
            this.$message.warning(res.msg);
          }
          this.addBtnStatus = true;
          //操作完相应数据清空
          this.editSendData = {
            id: "",
            index: "",
            is_stataus: false,
          };
        });
      }
    },
    // 预览
    preview() {
      if (this.previewId !== "") {
        preview({
          app_id: this.app_id,
          token: this.token,
          message_id: this.previewId,
        }).then((res) => {
          console.log("预览信息", res);
          if (res.code == 200) {
            this.$alert(
              `<img style='width: 200px' src='${res.data}'>`,
              "二维码",
              {
                dangerouslyUseHTMLString: true,
                center: true,
              }
            );
          } else {
            this.message.warning(res.msg);
          }
        });
        this.previewId = "";
      } else {
        this.$message.warning("请先选择一个消息进行预览查看！！");
      }
    },
    //处理数据,并清除
    dispose(data, sendTyle) {
      let newData = {
        id: data.id,
        type: data.type,
      };
      if (sendTyle == 1) {
        let strings = data.value;
        let newstring = "";
        for (var i in strings) {
          if (strings[i] != "$" && strings[i] != '"') {
            newstring += strings[i];
          }
        }
        newData.value = newstring.replace(
          "{nickname}",
          "<img src='https://yckj-common.oss-cn-beijing.aliyuncs.com/1598235903.png'>"
        );
        console.log("nick", newData.value);
        this.text = "";
        this.editSend = "";
      }
      if (sendTyle == 2) {
        newData.url = data.url;
        this.imgData = "";
      }
      if (sendTyle == 3) {
        // console.log("图文", decodeURI(data.value));
        newData.value = data.value;
        this.textData = {
          title: "标题", //标题（图文）
          desc: "", //	描述
          url: "", //	url
          image: "", //	图片链接（图文）
        };
      }
      console.log("反馈数据", newData);
      if (this.editSendData.is_stataus) {
        // ture为编辑
        this.showMessageData[this.editSendData.index] = newData;
      } else {
        this.showMessageData.push(newData);
      }
      // localStorage.setItem("syore");
    },
    delUrl() {
      this.textData.image = "";
    },
    onSubmit() {
      // //
      if (this.showMessageData.length == 0) {
        return this.$message.warning("您还没有创建消息请先设置推送内容！！");
      } else {
        var messageShell = [];
        this.showMessageData.forEach((item) => {
          messageShell.push(item.id);
        });
      }

      // //规则生效时间
      // console.log("11");
      let data = {
        app_id: this.app_id,
        token: this.token,
        name: this.form.name,
        type: this.form.type,
        send_time: this.form.send_time,
        is_forever: this.form.is_forever,
        is_differ: this.form.is_differ,
        message_id: messageShell.join(","),
      };
      // 规则内容

      if (this.form.name == "") {
        return this.$message.warning("请填写规则名称！！");
      }
      // 发送类型
      if (this.form.send_time == "2") {
        // 等待發送
        if (this.form.hour == "" || this.form.minute == "") {
          return this.$message.warning("请完善等待时间！！");
        } else {
          data.wait_time = {
            hour: this.form.hour,
            minute: this.form.minute,
          };
        }
      } else if (this.form.send_time == "3") {
        //定期发送
        if (this.form.timing_time == "everyday") {
          if (this.form.time == "") {
            this.form.weekArr = [];
            return this.$message.warning("请完善定期发送时间！！");
          } else {
            data.timing_time = {
              everyday: this.form.time,
            };
          }
        } else {
          // 按周
          if (this.form.time == "" || this.form.weekArr.length == 0) {
            return this.$message.warning("请完善定期发送时间！！");
          } else {
            //  数据整合

            let objWeek = {}; //
            this.form.weekArr.forEach((item) => {
              let arr = [];
              arr.push(this.form.time);
              objWeek[item] = arr;
            });
            data.timing_time = {
              weekly: objWeek,
            };
          }
        }
      }
      //
      if (this.form.is_forever == "0") {
        if (!this.form.foreverTime.length) {
          return this.$message.warning("请选择规则生效的时间！！");
        } else {
          data.start_time = this.form.foreverTime[0];
          data.end_time = this.form.foreverTime[1];
        }
      }
      console.log(" senddata", data);
      // return;
      if (!this.jude) {
        smartRuleAdd(data).then((res) => {
          console.log("send", res);
          if (res.code == 200) {
            this.$message.success(res.msg);
          } else {
            this.$message.warning(res.msg);
          }
          this.$router.push("smartIndex");
        });
      } else {
        data.id = this.$route.query.idJ;
        smartRuleEditor(data).then((res) => {
          console.log("send", res);
          if (res.code == 200) {
            this.$message.success(res.msg);
          } else {
            this.$message.warning(res.msg);
          }
          this.$router.push("smartIndex");
        });
      }
      // smartRuleEditor()
    },
    // 刪除客服消息
    deleteMessage(item, index) {
      let data = {
        app_id: this.app_id,
        token: this.token,
        id: item.id,
      };
      smartRuleDel(data).then((res) => {
        if (res.code == 200) {
          this.$message.success("删除成功！");
          this.showMessageData.splice(index, 1);
        } else {
          this.$message.warning("删除失败！");
        }
      });
    },
    // 编辑客服消息
    editMessage(item, index) {
      this.editSendData.is_stataus = true; //改为编辑状态
      this.editSendData.id = item.id;
      this.editSendData.index = index;
      switch (item.type) {
        case "text":
          this.addBtnStatus = false;
          this.text = item.value;
          break;
        case "image":
          this.typeImg(2);
          break;
        case "news":
          this.dialogVisible = true;
          this.textData = item.value;
          break;
      }
    },
    //对象数据
    // initData() {
    //   let data = {
    //     token: this.token,
    //     app_id: this.app_id
    //   };
    //   allTag(data).then(res => {
    //     console.log("标签", res);
    //     if (res.code == 200) {
    //       this.tagsData = res.data;
    //     }
    //   });
    //   vipList(data).then(res => {
    //     console.log("会员等级", res);
    //     if (res.code == 200) {
    //       this.vipData = res.data;
    //     }
    //   });
    //   // vipList
    // },
    // 关闭弹窗
    dialogPhotoClose(type) {
      // type 0 图片， 1 为图文消息关闭时图文数据进行清除
      if (type == 1) {
        this.dialogVisible = false;
        this.textData = {
          title: "标题", //标题（图文）
          desc: "", //	描述
          url: "", //	url
          image: "", //	图片链接（图文）
        };
      } else {
        this.dialogPhoto = false;
      }
      // 避免编辑状态混乱
      this.editSendData.is_stataus = false;
    },
    keepLastIndex(obj) {
      if (window.getSelection) {
        //ie11 10 9 ff safari
        obj.focus(); //解决ff不获取焦点无法定位问题
        var range = window.getSelection(); //创建range
        range.selectAllChildren(obj); //range 选择obj下所有子内容
        range.collapseToEnd(); //光标移至最后
      } else if (document.selection) {
        //ie10 9 8 7 6 5
        var rangeNew = document.selection.createRange(); //创建选择对象
        //var range = document.body.createTextRange();
        rangeNew.moveToElementText(obj); //rangeNew定位到obj
        rangeNew.collapse(false); //光标移至最后
        rangeNew.select();
      }
    },
  },
};
</script>
<style scoped lang="scss">
.inputWidth {
  width: 120px;
}
a {
  color: #409eff !important;
  text-decoration: underline;
}
.active {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .top {
    height: 80px;
    padding: 20px;
  }
  // 設置
  .box {
    flex: 1;
  }
  .box1 {
    padding: 20px;
    .showMessage {
      padding: 25px 0;
      border-bottom: 1px solid #e5e5e5;
      display: flex;
      .showMessageContent {
        flex: 1;
        min-height: 10px;
      }
      .showMessageBtn {
        width: 86px;
        display: flex;
        justify-content: space-between;
        i {
          // width: 20px;
          // height: 20px;
          font-size: 20px;
          cursor: pointer;
          color: #b8bbc0;
        }
      }
    }
    .currentShowMessage {
      border-bottom: 1px solid #409eff;
    }
    .textEditor {
      width: 100%;
      margin-top: 22px;

      #text_area,
      ::v-deep .el-textarea__inner {
        height: 240px !important;
        border-radius: 0;
        border: 1px solid #dcdfe6;
        a,
        a:hover,
        a:link,
        a:visited,
        a:active {
          color: #409eff !important;
          text-decoration: underline;
        }
        ::v-deep a {
          color: #409eff !important;
          text-decoration: underline;
        }
      }
      .options {
        height: 40px;
        padding-left: 14px;
        border-top: 1px solid #e7e7eb;
        display: flex;
        border: 1px solid #dcdfe6;
        border-top: 0;
        justify-content: space-between;
      }
      .optionLeft {
        display: flex;
        div.icon {
          width: 24px;
          height: 24px;
          margin: 9px 16px 9px 0;
          cursor: pointer;
        }

        .svgIcon {
          color: #325aa8;
          font-size: 24px;
          line-height: 38px;
          cursor: pointer;
          margin-right: 20px;
          -webkit-transition: 0.3s;
          transition: 0.3s;
        }

        .svgIcon:not(.kucun):hover {
          color: #4c566c;
        }

        .svgIcon.unActive:hover {
          color: #b3b6bc;
        }

        .linkIcon {
          background: url("../../../../../../../../public/img/icon-link.png")
            center left no-repeat;
          position: relative;
        }

        .linkIcon #fai-url-panel {
          left: 0 !important;
          top: 25px !important;
        }

        .linkIcon:hover {
          background: url("../../../../../../../../public/img/icon-link-selected.png")
            center left no-repeat;
        }

        .face {
          background: url("../../../../../../../../public/img/icon-face.png")
            center left no-repeat;
          position: relative;
        }

        .face:hover {
          background: url("../../../../../../../../public/img/icon-face-selected.png")
            center left no-repeat;
        }

        .nickNameIcon {
          background: url("../../../../../../../../public/img/icon-nickName.png")
            center left no-repeat;
          position: relative;
          cursor: pointer;
        }

        .nickNameIcon:hover {
          background: url("../../../../../../../../public/img/icon-nickName-selected.png")
            center left no-repeat;
          cursor: pointer;
        }
      }
      .optionRigth {
        display: flex;
      }

      .options .wordnum {
        font-size: 14px;
        line-height: 40px;
        margin-right: 16px;
      }

      .options .subimitbtn {
        width: 48px;
        height: 26px;
        line-height: 26px;
        margin: 7px 8px 7px 0;
        background: #1bbb67;
        color: #fff;
        text-align: center;
        border-radius: 4px;
        cursor: pointer;
        -webkit-transition: 0.3s;
        transition: 0.3s;
      }

      .options .subimitbtn:hover {
        background: #05a953;
      }
    }
    .title {
      padding-top: 10px;
      color: #979ba0;
    }
    .addMessage {
      width: 40px;
      height: 40px;
      overflow: hidden;
      margin-top: 32px;
      cursor: pointer;
      i {
        font-size: 16px;
      }
      .el-icon-plus {
        padding: 10px;
        color: #eee;
      }
      border-radius: 20px;
      border: 1px solid #eee;

      transition: 0.3s;
    }
    .addMessage:hover {
      width: 360px;
      display: flex;
      align-items: center;
      border: 1px solid #409eff;

      div {
        width: 104px;
        cursor: pointer;
      }
      transition: 0.3s;
    }
  }
  .box2 {
    .box2Top {
      height: 50px;
      background: rgba(255, 255, 255, 1);
      border-radius: 2px;
      // padding: 0 24px;
      margin: 20px;
      border-bottom: 1px solid #eee;
      font-size: 18px;
      color: rgba(0, 0, 0, 0.75);
    }
    .el-form {
      width: 50%;
    }
  }
  // 底部

  .bottom {
    height: 80px;
    border-top: 1px solid #eee;
    text-align: center;
    padding-top: 20px;
  }
}
// 圖文彈窗
.clearfix {
  display: flex;
}
#fai-message-conten {
  padding: 32px 0 32px 32px;
  min-height: 336px;
  max-height: 600px;
  overflow-y: auto;
}

#fai-message-conten .left {
  width: 328px;
}

#fai-message-conten .left .mItem {
  position: relative;
}

#fai-message-conten .left .mItem .imgBox {
  height: 224px;
  overflow: hidden;
  img {
    height: 100%;
  }
}

// #fai-message-conten .left .mItem .imgBoxBg {
//   background-image: url(../public/img/defImage.jpg?v=201905061522);
//   background-size: 100%;
//   background-position: center;
// }

#fai-message-conten .left .mItem .title {
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
  width: 328px;
  // width: 304px;
  max-height: 224px;
  line-height: 30px;
  padding: 7px 12px;
  overflow: hidden;
  word-wrap: break-word;
  word-break: break-all;
  position: absolute;
  bottom: 0;
}

#fai-message-conten .left .item {
  padding: 24px 24px 10px 12px;
  border: 1px solid #e8e8eb;
  border-top: 0;
  position: relative;
}

#fai-message-conten .imgBox img {
  width: 100%;
}

#fai-message-conten .left .item .imgBox {
  float: right;
  height: 78px;
  line-height: 78px;
  width: 78px;
  background: #e8e8eb;
  color: #bfc2c4;
  text-align: center;
  overflow: hidden;
  position: relative;
  margin-left: 10px;
}

#fai-message-conten .left .item .imgBox img {
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

#fai-message-conten .left .item .title {
  height: 78px;
  overflow: hidden;
  word-wrap: break-word;
  word-break: break-all;
  color: #959c9f;
}

#fai-message-conten .left .addItemWrap {
  border: 1px solid #e8e8eb;
  border-top: 0;
  padding: 16px;
}

#fai-message-conten .left .addItem {
  height: 100px;
  background: url(/image/menu_add.png?v=201905061522) center 28px no-repeat;
  border: 1px dashed #e7e7eb;
  cursor: pointer;
}

#fai-message-conten .left .addItem:hover {
  border-color: #b3b3b3;
  background-image: url(/image/menu_add_hover.png?v=201905061522);
}

#fai-message-conten .left .mItem .mask {
  height: 224px;
  line-height: 224px;
  left: 0;
}

#fai-message-conten .left .mask {
  position: absolute;
  top: 0;
  left: -1px;
  width: 328px;
  height: 113px;
  line-height: 113px;
  background: rgba(0, 0, 0, 0.5);
  text-align: center;
}

#fai-message-conten .icon {
  width: 20px;
  height: 20px;
  vertical-align: middle;
  display: inline-block;
  overflow: hidden;
  cursor: pointer;
}

#fai-message-conten .left .icon {
  margin: 0 10px;
}

#fai-message-conten .icon.edit {
  background: url(/image/icon-edit.png?v=201905061522) 0 0 no-repeat;
}

#fai-message-conten .left .icon.edit:hover {
  background-image: url(/image/icon_edit_selected.png?v=201905061522);
}

#fai-message-conten .icon.del {
  background: url(/image/icon-del.png?v=201905061522) 0 0 no-repeat;
}

#fai-message-conten .left .icon.del:hover,
#fai-message-conten .right .faiui-btn:hover .icon.del {
  background-image: url(/image/icon-del-selected.png?v=201905061522);
}

#fai-message-conten .icon.upload {
  background: url(/image/upload.png?v=201905061522) 0 0 no-repeat;
}

#fai-message-conten .right .icon.del {
  vertical-align: text-bottom;
}

#fai-message-conten .right {
  margin-left: 32px;
  width: 316px;
  -webkit-transition: all linear 0.2s;
  transition: all linear 0.2s;
  float: left;
  border: 1px solid #e7e7eb;
  padding: 0 12px;
}

#fai-message-conten .arrow_out {
  position: absolute;
  width: 0;
  height: 0;
  border-width: 12px;
  border-style: dashed;
  border-color: transparent;
  border-left-width: 0;
  border-right-color: #e7e7eb;
  border-right-style: solid;
  top: 34px;
  left: -13px;
}

#fai-message-conten .arrow_in {
  position: absolute;
  width: 0;
  height: 0;
  border-width: 12px;
  border-style: dashed;
  border-color: transparent;
  border-left-width: 0;
  border-right-color: #fff;
  border-right-style: solid;
  top: 34px;
  left: -11px;
}

#fai-message-conten .right textarea {
  padding: 4px;
  height: 100px;
  line-height: normal;
}

#fai-message-conten .right .exp {
  color: #b8bbc0;
  padding-left: 10px;
  font-size: 12px;
}

#fai-message-conten .right .faiui-urlInput .faiui-input {
  width: 242px;
}

#fai-message-conten .right .baseLine {
  position: relative;
  margin-bottom: 20px;
}

#fai-message-conten .right .baseLine2 {
  margin-top: 8px;
}

#fai-message-conten .right .imgBox {
  padding: 3px;
  border: 1px solid #e8e8eb;
  width: 144px;
}

#fai-message-conten .right .progressBox {
  display: inline-block;
}
</style>
